import { keys, find } from 'ramda';
import {
  useIntl,
  injectIntl,
  IntlShape,
  FormattedMessage as FormattedHTMLMessageBase,
} from 'react-intl';

import IntlProvider from './IntlProvider';
import { useFormatMessage as useFormatMessageHook } from './hooks/hooks';
export { useCurrency } from './hooks/hooks';

export interface RawMessagesType {
  [key: string]: [null, string];
}

export type IntlProviderType = IntlShape;

export const getLabelByIntlPrefix = (
  obj: {
    [key: string]: any;
  },
  prefix: string,
  callbackProperty: string
) => {
  const intlProperty = find((prop: any) => {
    const regex = new RegExp(`^${prefix}_*`, 'g');
    return regex.test(prop);
  }, keys(obj));
  return obj[intlProperty] || obj[callbackProperty];
};

export const m = (
  id: string,
  callbackMessage: string,
  description?: string
) => ({
  id,
  description,
  defaultMessage: callbackMessage,
});

export const useFormatMessage = useFormatMessageHook;
export const FormattedHTMLMessage = FormattedHTMLMessageBase;

export default {
  Provider: IntlProvider,
  withIntl: injectIntl,
  useIntl,
};
